import styled from 'styled-components';

import { SpaceContentProps } from './LocationCards.types';

export const LocationContainer = styled.div<SpaceContentProps>`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: stretch;

  ${({ $centerContent }) => `
    justify-content: ${$centerContent ? 'space-evenly' : 'flex-start'};
  `}
  margin-top: 40px;
  @media screen and (max-width: 1288px) {
    justify-content: space-evenly;
  }
  @media ${({ theme }) => theme.queries.maxTablet} {
    flex-direction: column;
  }
  width: 100%;
  min-height: 100px;
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
`;
